import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppSettings } from '../../utils/app-settings';
import { IGetShippingResponse, ShippingStatus, ShippingPriority } from '../../interfaces/deliveries.interface';
import { IGetReturnByIDReponse, IGetReturnsPaginatedResponse, Driver } from '../../interfaces/returns.interface';
import {
  FileUploadService,
  UploadResponse,
} from '../file-upload/file-upload.service';

interface IGetDriversResponse {
  statusCode: number;
  message: string;
  data: Driver[];
}

@Injectable({
  providedIn: 'root',
})

export class ReturnsService {
  constructor(
    private http: HttpClient,
    private appSettings: AppSettings,
    private fileUploadService: FileUploadService
  ) {}

  getReturns(page?: number, pageSize?: number, status?: ShippingStatus, priority?: ShippingPriority, q?: string, carrier?: string, driverId?: number): Observable<IGetReturnsPaginatedResponse> {
    const params: string[] = [];
    if (page !== undefined) params.push(`page=${page}`);
    if (pageSize !== undefined) params.push(`pageSize=${pageSize}`);
    if (status) params.push(`status=${status}`);
    if (priority) params.push(`priority=${priority}`);
    if (q) params.push(`q=${encodeURIComponent(q)}`);
    if (carrier) params.push(`carrier=${encodeURIComponent(carrier)}`);
    if (driverId !== undefined) params.push(`driverId=${driverId}`);
    const url = params.length
      ? `${this.appSettings.returns.urls.getReturns}?${params.join('&')}`
      : this.appSettings.returns.urls.getReturns;
    return this.http.get<IGetReturnsPaginatedResponse>(url);
  }

  getReturnById(id: string): Observable<IGetReturnByIDReponse> {
    return this.http.get<any>(
      this.appSettings.returns.urls.getReturns + '/' + id
    );
  }

  getDriversWithReturns(): Observable<Driver[]> {
    return this.http
      .get<IGetDriversResponse>(this.appSettings.returns.urls.getDriversWithReturns)
      .pipe(map((response) => response.data));
  }

  /**
   * Upload file for a specific return
   */
  uploadFile(
    returnId: number,
    file: File
  ): Observable<HttpEvent<UploadResponse>> {
    return this.fileUploadService.uploadReturnFile(returnId, file);
  }
}
